import { render } from "./AddStaffOrder.vue?vue&type=template&id=16f9eebe"
import script from "./AddStaffOrder.vue?vue&type=script&lang=js"
export * from "./AddStaffOrder.vue?vue&type=script&lang=js"

import "@/assets/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./AddStaffOrder.vue?vue&type=style&index=1&id=16f9eebe&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__